/** Whether `value` is a non-null object — arrays and class instances included, unlike `isRecord`, which rejects both. */
export function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}
